export const FOUR_SPORT_LIVE_URL = 'https://www.4sport-live.com'

